import EventCourse from '@model/EventCourse'
import { Model } from 'pinia-orm'
import { BelongsTo, Bool, Num, Str, Uid } from 'pinia-orm/decorators'

export enum CourseObjectType {
    Mark = 'mark',
    Gate = 'gate',
    Boat = 'boat',
    Obstacle = 'obstacle',
    Text = 'text',
    Wind = 'wind',
    RaceLine = 'raceline'
}

export default class EventCourseObject extends Model {
    static entity = 'events-courses-objects'

    @Uid() declare id: string
    @Uid() declare eventId: string      // For sharding
    @Uid() declare eventCourseId: string
    @BelongsTo( () => EventCourse, 'eventCourseId' ) declare course: EventCourse

    @Str( CourseObjectType.Mark ) declare type: CourseObjectType
    @Num( 0 ) declare x: number
    @Num( 0 ) declare y: number
    @Num( 0 ) declare x2: number
    @Num( 0 ) declare y2: number
    @Num( 0 ) declare x3: number
    @Num( 0 ) declare y3: number
    @Str( '' ) declare label: string
    @Str( '' ) declare secondLabel: string
    @Bool( false ) declare secondRaceline: boolean
    @Bool( false ) declare sharedRaceline: boolean
    @Bool( false ) declare reversedDirection: boolean
    @Bool( false ) declare secondReversedDirection: boolean
    @Num( 0 ) declare rotation: number
    @Str( 'white' ) declare color: string
    @Str( 'white' ) declare secondColor: string
    @Str( 'white' ) declare thirdColor: string
    @Str( 'sphere' ) declare shape: string
    @Str( 'sphere' ) declare secondShape: string
    @Str( 'left' ) declare direction: string
    @Str( 'none' ) declare colorFlag1: string
    @Str( 'none' ) declare colorFlag2: string

    @Bool( true ) declare showDirection: boolean
    @Str( '' ) @Num( null ) declare nextObjectId: string | null
    @Bool( false ) declare nextObjectIdSecondary: boolean
    @Str( '' ) @Num( null ) declare prevObjectId: string | null
    @Bool( false ) declare prevObjectIdSecondary: boolean

    get dump () {
        return {
            type: this.type,
            x: this.x,
            y: this.y,
            x2: this.x2,
            y2: this.y2,
            x3: this.x3,
            y3: this.y3,
            label: this.label,
            secondLabel: this.secondLabel,
            secondRaceline: this.secondRaceline,
            sharedRaceline: this.sharedRaceline,
            reversedDirection: this.reversedDirection,
            secondReversedDirection: this.secondReversedDirection,
            rotation: this.rotation,
            color: this.color,
            secondColor: this.secondColor,
            thirdColor: this.thirdColor,
            shape: this.shape,
            secondShape: this.secondShape,
            direction: this.direction,
            showDirection: this.showDirection,
            nextObjectId: this.nextObjectId,
            nextObjectIdSecondary: this.nextObjectIdSecondary,
            prevObjectId: this.prevObjectId,
            prevObjectIdSecondary: this.prevObjectIdSecondary,
            colorFlag1: this.colorFlag1,
            colorFlag2: this.colorFlag2
        }
    }
}
